import React from "react";
import { ThemeProvider } from "styled-components";
import AppRouter from "./routers/AppRouter";
import AppProvider from "./store/provider";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import InstallBanner from "./components/pwa/InstallBanner";
import SupportWidget from "./components/support/SupportWidget";
import ScanLimitDialog from "./components/specsheet/ScanLimitDialog";
import feedbackTheme from "./theme/feedback";

export const SpectreApp = () => {
  return (
    <React.Suspense fallback={<div>Loading...</div>}>
      <ThemeProvider theme={feedbackTheme}>
        <AppProvider>
          <AppRouter />
          <ToastContainer
            position={feedbackTheme.toast.position}
            autoClose={feedbackTheme.toast.autoClose.success}
            hideProgressBar={false}
            closeOnClick
            pauseOnHover
            draggable
          />
          <InstallBanner />
          <SupportWidget />
          {/* Here rather than inside the spec sheet: a scan is started from
              several screens, and "you are out of sheets" has to be able to
              land on all of them. */}
          <ScanLimitDialog />
        </AppProvider>
      </ThemeProvider>
    </React.Suspense>
  );
};
